import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h1 className="footer-brand">NEKSIO LAND</h1>
        <p className="footer-phone"><a href="mailto:office@neks.ro"><b>office@neks.ro</b></a></p>
        <p className="footer-copyright">© {new Date().getFullYear()} Neksio Land. CUI: RO 33069300. Toate drepturile rezervate.</p>
      </div>
    </footer>
  );
};

export default Footer;
